export interface IAppSettings {
  apiUrl: string;
}

let cache = {};

export function getAppSetting(key: string) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return cache[key];
}

export function initializeAppSettings(settings: IAppSettings) {
  cache = { ...settings };
  Object.freeze(cache);
}
